import { render, staticRenderFns } from "./profile-fidelite-card.vue?vue&type=template&id=3cf3adfc"
import script from "./profile-fidelite-card.vue?vue&type=script&lang=ts"
export * from "./profile-fidelite-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf3adfc')) {
      api.createRecord('3cf3adfc', component.options)
    } else {
      api.reload('3cf3adfc', component.options)
    }
    module.hot.accept("./profile-fidelite-card.vue?vue&type=template&id=3cf3adfc", function () {
      api.rerender('3cf3adfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/profile-fidelite-card.vue"
export default component.exports